const BatchActions = ({ 
    selectedOrders,
    filteredOrders,
    onSelectAll,
    onGenerateInvoices,
    onGenerateLabels,
    isLoading,
    currentFilter
 }) => {
    const hasSelectedOrders = selectedOrders.length > 0;
    const allSelected = selectedOrders.length === filteredOrders.length;
    
    // Controle de visibilidade dos botões baseado no filtro atual
    const showInvoiceButton = currentFilter === 'needsInvoice' || currentFilter === 'withoutInvoice';
    const showLabelButton = currentFilter === 'needsLabel' || currentFilter === 'withInvoice';
    const showReprintButton = currentFilter === 'readyToShip';
 
    return (
        <div style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            padding: '15px 0',
            borderTop: '1px solid #eee'
        }}>
            {/* Seleção em Massa */}
            <div>
                <input
                    type="checkbox"
                    checked={allSelected && filteredOrders.length > 0}
                    onChange={() => onSelectAll(filteredOrders)}
                    style={{ cursor: 'pointer', marginRight: '8px' }}
                />
                <label style={{ cursor: 'pointer' }}>
                    Selecionar Todos ({selectedOrders.length}/{filteredOrders.length})
                </label>
            </div>
 
            {/* Botões de Ação */}
            <div style={{ display: 'flex', gap: '10px' }}>

                {showInvoiceButton && (
                    <button
                        onClick={() => onGenerateInvoices(selectedOrders)}
                        disabled={isLoading || !hasSelectedOrders}
                        style={{
                            backgroundColor: '#2D3277',
                            color: 'white',
                            padding: '8px 16px',
                            border: 'none',
                            borderRadius: '4px',
                            cursor: hasSelectedOrders ? 'pointer' : 'not-allowed',
                            opacity: (isLoading || !hasSelectedOrders) ? 0.7 : 1
                        }}
                    >
                        {isLoading ? (
                            <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                <LoadingSpinner />
                                Emitindo Nota Fiscal...
                            </div>
                        ) : 'Emitir Nota Fiscal'}
                    </button>
                )}

                {showLabelButton && (
                    <button
                        onClick={() => onGenerateLabels(selectedOrders)}
                        disabled={isLoading || !hasSelectedOrders}
                        style={{
                            backgroundColor: '#2D3277',
                            color: 'white',
                            padding: '8px 16px',
                            border: 'none',
                            borderRadius: '4px',
                            cursor: hasSelectedOrders ? 'pointer' : 'not-allowed',
                            opacity: (isLoading || !hasSelectedOrders) ? 0.7 : 1
                        }}
                    >
                        {isLoading ? (
                            <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                <LoadingSpinner />
                                Gerando Etiqueta...
                            </div>
                        ) : 'Gerar Etiqueta'}
                    </button>
                )}
 
                {showReprintButton && (
                    <button
                        onClick={() => onGenerateLabels(selectedOrders)}
                        disabled={isLoading || !hasSelectedOrders}
                        style={{
                            backgroundColor: '#2D3277',
                            color: 'white',
                            padding: '8px 16px',
                            border: 'none',
                            borderRadius: '4px',
                            cursor: hasSelectedOrders ? 'pointer' : 'not-allowed',
                            opacity: (isLoading || !hasSelectedOrders) ? 0.7 : 1
                        }}
                    >
                        {isLoading ? (
                            <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                <LoadingSpinner />
                                Reemitindo Etiqueta...
                            </div>
                        ) : 'Emitir Etiqueta Novamente'}
                    </button>
                )}
            </div>
        </div>
    );
 };
 
 // Componente de loading
 const LoadingSpinner = () => (
    <div style={{
        width: '20px',
        height: '20px',
        border: '3px solid #f3f3f3',
        borderTop: '3px solid #ffffff',
        borderRadius: '50%',
        animation: 'spin 1s linear infinite'
    }} />
 );
 
 export default BatchActions;